import { Input, Select } from '@frontend/design_system'
import { LOCATION_ADDING_FORM_VALUES } from 'texts/locationDetails'
import { StateFieldProps } from './types'
import { ItemType } from 'ui/atoms/Select/types'

export const StateField = ({
  states,
  value,
  onChange,
  error,
  isStateWithDropdown,
  handleStateChange,
  disabled,
  dataTestId,
}: StateFieldProps) =>
  isStateWithDropdown ? (
    <Select
      size="large"
      placeholder={LOCATION_ADDING_FORM_VALUES.STATE.SELECT_PLACEHOLDER}
      onChange={(el: string, item: ItemType) => {
        onChange(el, item)
        handleStateChange(item)
      }}
      label={LOCATION_ADDING_FORM_VALUES.STATE.SELECT_LABEL}
      items={states}
      error={error}
      noSpaceForError
      selectedValue={value}
      isRequired
      dataTestId={dataTestId}
      search={{
        placeholder: LOCATION_ADDING_FORM_VALUES.STATE.SEARCH_PLACEHOLDER,
      }}
      disabled={disabled}
    />
  ) : (
    <Input
      value={value}
      placeholder={LOCATION_ADDING_FORM_VALUES.STATE.PLACEHOLDER}
      size="large"
      error={error}
      spaceForError="none"
      maxLength={50}
      onChange={onChange}
      dataTestId={dataTestId}
      isDisabled={disabled}
      label={LOCATION_ADDING_FORM_VALUES.STATE.LABEL}
    />
  )
